<app-header [selectedMenu]="MENU_PAGE.HOMONYM"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->

  <div class="wrapper">
    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div #extContainer
           class="inner wrap flex-column">

        <app-search-box #extHeader
                        [keyword]="keyword"
                        [placeholder]="placeholder"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_HOMONYM"
                        [top]="scrollTop"
                        (search)="onSearch($event)"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout">

            <div #extBody2
                 class="book-layout-wrap">

              <div class="book-page-list">

                <app-jaso-index-homonym [curJasoIdx]="curJasoIdx"
                                        [second]="false"
                                        (search)="onSearch($event)"></app-jaso-index-homonym>

                <div #extBody
                     class="book-page-group">

                  <div class="page-box {{ isNoResult() ? 'empty' : '' }}">
                    <div #container
                         (scroll)="onScroll($event)"
                         class="page-contents scroll-effect over-y">

                      <article class="mean-list-layout1"
                               [class.empty]="isNoResult()">

                        <div #innerScroll
                             class="list-wrap">

                          <ul #listHomonym>

                            <li *ngFor="let homonym of ll.getList() ?? null"
                                id="{{ listItemId(homonym.name) }}"
                                class="list-style-{{ homonym.overSize ? 'row' : 'box' }} border">

                              <div *ngFor="let word of homonym.listWord"
                                   class="list-item-box"
                                   (click)="onClickWord($event, word.id)">
                                <app-homonym-word-item [word]="word"
                                                       (selectWord)="onSelectWord($event)"
                                                       (viewInit)="onChildViewInit($event)"
                                                       (sizeOver)="homonym.overSize = $event"></app-homonym-word-item>

                              </div>

                              <app-homonym-all-play-btn [homonym]="homonym"></app-homonym-all-play-btn>


                            </li>

                            <!-- 로딩중 표시 -->
                            <li class="reload-icon" *ngIf="ll && !ll.IsComplete()">
                              <img #reload src="assets/img/loading_icon.gif">
                            </li>

                            <!-- 항목 없음 표시 -->
                            <li class="no-result" *ngIf="isNoResult()">
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">단어가 없습니다.</div>
                            </li>
                          </ul>


                        </div>

                      </article>


                    </div>

                  </div>
                  <div class="page-box {{ isNoResult() ? 'empty' : '' }}">

                    <app-word-help-btn></app-word-help-btn>

                    <app-word-detail *ngIf="curWord"
                                     [word_id]="curWord"
                                     [fromHomonym]="true"
                                     [autoPlay]="autoPlay"></app-word-detail>
                  </div>

                  <div *ngIf="showScrollDown"
                       class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>


  </div>


  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>


</div>
